import * as CurrentsSelectors from '../current';
import * as FilesConsts from '../../consts/files';

export const getFiles = (state = {}) =>
    state.files || {};

export const getFileIds = (state = {}) =>
    Object.keys(getFiles(state));

export const getFileById = (state, id) =>
    getFiles(state)[id] || {};

export const getCurrentFile = (state = {}) =>
    getFileById(state, CurrentsSelectors.getCurrentFileId(state));

export const getFilerrIdByFileId = (state, id) => {
    const { filerrId } = getFileById(state, id) || {};

    return filerrId;
};

export const getCurrentFileStatus = (state = {}) =>
    getCurrentFile(state).status;

export const getCurrentFileFilerrId = (state = {}) =>
    getCurrentFile(state).filerrId;

export const getFilerrIdsByFileIds = (state = {}, fileIds = []) =>
    Object.values(getFiles(state))
        .filter((file) => fileIds.includes(file.id))
        .map(({ filerrId }) => filerrId);

export const getFileByFileFilerrId = (state = {}, filerrId) =>
    Object.values(getFiles(state))
        .find((file) => file.filerrId === filerrId) || {};

export const getFileIdByFileFilerrId = (state = {}, filerrId) =>
    getFileByFileFilerrId(state, filerrId).id;

export const getFileIdsByFilerrIds = (state = {}, filerrIds = []) =>
    filerrIds.map((filerrId) => getFileIdByFileFilerrId(state, filerrId));

export const getFilesCount = (state) => getFileIds(state).length;

export const isEmpty = (state = {}) =>
    getFilesCount(state) === 0;

export const isActiveStatus = (state = {}) => getCurrentFileStatus(state) === FilesConsts.FILE_ACTIVE_STATUS;
